/**
 * Active Menu Navigation Script
 * Highlights menu items based on current scroll position
 */

(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initActiveMenu);
  } else {
    initActiveMenu();
  }

  function initActiveMenu() {
    var sections = Array.from(document.querySelectorAll('section[id]'));
    var links = Array.from(document.querySelectorAll('a[href*="#"]'));
    
    // Create a map of section IDs to corresponding links
    var map = new Map(sections.map(function(s) {
      return [s.id, links.filter(function(a) {
        var href = a.getAttribute('href');
        return href && href.indexOf('#' + s.id) !== -1;
      })];
    }));

    // Throttle scroll events for better performance
    var ticking = false;
    
    function updateActiveMenu() {
      // Get header height for offset calculation
      var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      var scrollY = window.scrollY + headerHeight + 1;
      
      // Find the current section based on scroll position
      var current = sections.filter(function(s) {
        return s.getBoundingClientRect().top + window.scrollY <= scrollY;
      }).pop();
      
      // Remove active class from all links
      links.forEach(function(a) {
        a.classList.remove('is-active');
      });
      
      // Add active class to current section's links
      if (current) {
        var currentLinks = map.get(current.id) || [];
        currentLinks.forEach(function(a) {
          a.classList.add('is-active');
        });
      }
      
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateActiveMenu);
        ticking = true;
      }
    }

    // Listen for scroll events
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // Initial call to set active state on page load
    updateActiveMenu();
  }
})();
